import GlassCard from '../ui/GlassCard';

const WalletIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3.5 w-3.5">
    <path
      d="M3 7a2 2 0 0 1 2-2h12l4 4v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="17" cy="13" r="1.4" fill="currentColor" />
  </svg>
);

function PresupuestoPill({ presupuesto, seleccionado, onSelect }) {
  const esSeleccionado = seleccionado === presupuesto.cdPresupuesto;
  const clasesBase =
    'inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium tracking-tight transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300/60';
  const clasesEstado = esSeleccionado
    ? 'border-violet-300/40 bg-gradient-to-br from-violet-500/90 via-violet-500/80 to-cyan-400/80 text-white shadow-glow'
    : 'border-white/10 bg-white/[0.04] text-white/70 hover:bg-white/[0.08] hover:text-white';
  return (
    <button
      type="button"
      onClick={() => onSelect(presupuesto.cdPresupuesto)}
      aria-pressed={esSeleccionado}
      className={`${clasesBase} ${clasesEstado}`}
    >
      <WalletIcon />
      {presupuesto.dePresupuesto}
    </button>
  );
}

function LoadingState() {
  return (
    <div className="flex items-center gap-3 px-1">
      <div className="h-5 w-24 overflow-hidden rounded-full bg-white/5">
        <div className="h-full w-full animate-shimmer bg-gradient-to-r from-transparent via-white/15 to-transparent bg-[length:200%_100%]" />
      </div>
      <div className="h-5 w-20 overflow-hidden rounded-full bg-white/5">
        <div className="h-full w-full animate-shimmer bg-gradient-to-r from-transparent via-white/15 to-transparent bg-[length:200%_100%]" />
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <p className="text-xs text-white/45">
      No hay presupuestos activos disponibles.
    </p>
  );
}

function ErrorState() {
  return (
    <p className="text-xs font-medium text-rose-300/85">
      No se pudieron cargar los presupuestos activos.
    </p>
  );
}

function PresupuestoSelector({
  presupuestos,
  isLoading,
  error,
  seleccionado,
  onSelect,
}) {
  return (
    <GlassCard className="px-5 py-4 sm:px-6">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1 text-[11px] font-mono uppercase tracking-[0.2em] text-white/55">
            <WalletIcon />
            Presupuestos activos
          </span>
          {seleccionado !== null && (
            <button
              type="button"
              onClick={() => onSelect(null)}
              className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45 transition hover:text-white/80"
            >
              Limpiar
            </button>
          )}
        </div>
        {isLoading ? (
          <LoadingState />
        ) : error ? (
          <ErrorState />
        ) : presupuestos.length === 0 ? (
          <EmptyState />
        ) : (
          <div className="flex flex-wrap gap-2">
            {presupuestos.map((presupuesto) => (
              <PresupuestoPill
                key={presupuesto.cdPresupuesto}
                presupuesto={presupuesto}
                seleccionado={seleccionado}
                onSelect={onSelect}
              />
            ))}
          </div>
        )}
      </div>
    </GlassCard>
  );
}

export default PresupuestoSelector;
